import { frontendURL } from '../../../../helper/URLHelper';
import BillingSettingsLayout from './BillingSettingsLayout.vue';
import WhatsappFees from '../account/WhatsappFees.vue';
import AiBillingUsage from '../account/AiBillingUsage.vue';
import OrganizationBilling from '../account/OrganizationBilling.vue';
import OrganizationBillingSelectPlan from '../account/OrganizationBillingSelectPlan.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/billing'),
      meta: {
        permissions: ['administrator'],
        fullWidth: true,
      },
      component: BillingSettingsLayout,
      children: [
        {
          path: '',
          name: 'general_settings_billing',
          component: OrganizationBilling,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'plans',
          name: 'general_settings_billing_plans',
          component: OrganizationBillingSelectPlan,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'whatsapp-fees',
          name: 'general_settings_whatsapp_fees',
          component: WhatsappFees,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'ai-billing',
          name: 'general_settings_ai_billing',
          component: AiBillingUsage,
          meta: {
            permissions: ['administrator'],
            fullWidth: true,
          },
        },
      ],
    },
  ],
};
